/**
 * sayfaBoyutu.js — liste sayfa boyutu seçenekleri (#728). SayfaBoyutuSecici.jsx ve adres çubuğunu okuyan servisler paylaşır.
 */
export const SAYFA_BOYUTLARI = [10, 25, 50, 100];
export const VARSAYILAN_SAYFA_BOYUTU = 10;

/** Adresten / dışarıdan gelen değeri geçerli bir sayfa boyutuna çevirir; tanınmayan değer varsayılana (10) düşer. */
export function sayfaBoyutuCozumle(deger) {
  const n = Number(deger);
  return SAYFA_BOYUTLARI.includes(n) ? n : VARSAYILAN_SAYFA_BOYUTU;
}
